import React from 'react'
import { observer } from 'mobx-react-lite'

import { Receipt as ReceiptOutlinedIcon } from '@mxenabled/mx-icons'

import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../../common'

interface ZeroStateProps {
  showIcon?: boolean
  showSubtitle?: boolean
}

const ZeroState: React.FC<ZeroStateProps> = ({ showIcon = true, showSubtitle = true }) => {
  const { transactions: copy } = useGlobalCopyStore()

  return (
    <Stack alignItems="center" gap={12} height="auto" mb={24} mt={24}>
      {showIcon && <ReceiptOutlinedIcon color="action" sx={{ fontSize: 32 }} />}
      <Text bold={true} color="text.secondary" variant="body2">
        {copy.zero_state_no_transactions}
      </Text>
      {showSubtitle && (
        <Text color="text.secondary" variant="caption">
          {copy.zero_state_there_are_no_transactions}
        </Text>
      )}
    </Stack>
  )
}

export default observer(ZeroState)
